import instance from './instance';

export const createFeedbackComment = ({ uuid, body, video, feedbackUuid, userId }) => {
  const data = new FormData();
  data.append('feedbackComment[uuid]', uuid);
  data.append('feedbackComment[body]', body);
  data.append('feedbackComment[feedbackUuid]', feedbackUuid);
  data.append('feedbackComment[userId]', userId);
  if (video) {
    data.append('feedbackComment[video][video_attributes][webm_file]', video.file);
    data.append('feedbackComment[video][video_attributes][audio_only]', video.audioOnly);
  }
  return instance.postForm('/feedback_comments', data);
};

export function updateFeedbackComment(data) {
  return instance.put(`/feedback_comments/${data.uuid}`, data);
}

export function destroyFeedbackComment(uuid) {
  return instance.delete(`/feedback_comments/${uuid}`);
}

export const viewFeedbackComment = commentUuid => instance.post(`/feedback_comments/${commentUuid}/comment_viewed`);
